<template>
  <div class="select">
    <v-select
      outlined
      rounded
      dense
      :height="height"
      hide-details="auto"
      @change="onchange"
      placeholder="請選擇"
      :items="items"
      :value="value"
      item-text="label"
      item-value="value"
      :clearable="clearable"
      :disabled="disabled"
      :error-messages="errorsMsg">
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    items: {
      type: [Array],
    },
    height: {
      type: [String],
      default() {
        return '32px';
      },
    },
    value: {
      type: [String, Number, Object],
    },
    selectIndex: {
      type: [Number],
    },
    clearable: {
      type: [Boolean],
      default() {
        return true;
      },
    },
    disabled: {
      type: [Boolean],
    },
    errorsMsg: {
      type: [String, Array],
    },
  },
  methods: {
    onchange(val) {
      this.$emit('input', val, this.selectIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  max-width: 200px;
  display: inline-block;
}

::v-deep.v-text-field.v-select .v-input__control .v-input__slot {
  input {
    line-height: initial;
  }
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px;
  background-color: $white;
  .v-input__append-inner {
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
